import { httpClient } from "../../../http-client";
import { ApiUrlBuilder } from "../../shared/constants/apiUrl";
import { MappedAreaModel } from "../models/mapped-area-model";
import { PlanView } from "../types/plan.types";
import { getCause } from '../../../http-client/interceptors/error.interceptor';
import { AssetAncestorModel } from '../models/asset-ancestor-model';
import { AssetAncestorView } from '../types/asset-ancestor.types';

const MappedAreaServiceImplementation = {
  getFloorMappedArea: (orga: string, floorId: string): Promise<MappedAreaModel> =>
    httpClient
      .get(ApiUrlBuilder.getFloor(orga, floorId))
      .then((response) => response.json())
      .then((response) => {
        const isPlanView = (planView: any): planView is PlanView => "planSvg" in planView && "name" in planView && "isExported" in planView;
        if (isPlanView(response)) {
          return new MappedAreaModel(response.planSvg, response.name, response.isExported);
        } else {
          throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause(response?.status || 500) });
        }
      }),
  getOutdoorAreasMappedArea: (orga: string, siteId: string): Promise<MappedAreaModel> =>
    httpClient
      .get(ApiUrlBuilder.getOutdoorAreasPlan(orga, siteId))
      .then((response) => response.json())
      .then((response) => {
        const isPlanView = (planView: any): planView is PlanView => "planSvg" in planView && "name" in planView && "isExported" in planView;
        if (isPlanView(response)) {
          return new MappedAreaModel(response.planSvg, response.name, response.isExported);
        } else {
          throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause(response?.status || 500) });
        }
      }),
  getAssetAncestors: (orga: string, assetId: string): Promise<AssetAncestorModel[]> =>
        httpClient
          .get(ApiUrlBuilder.getAssetAncestors(orga, assetId))
          .then((response) => response.json())
          .then((response) => {
            const isAssetAncestorView = (assetAncestorView: any): assetAncestorView is AssetAncestorView => "assetId" in assetAncestorView && "assetType" in assetAncestorView;
        
            if (Array.isArray(response)) {
              return response.map((assetAncestorView: unknown) => {
                if (isAssetAncestorView(assetAncestorView)) {
                  return new AssetAncestorModel(
                    assetAncestorView.assetId,
                    assetAncestorView.assetType,
                  );
                } else {
                  throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause( 500) });
                }
              });
            } else {
              throw new Error(`response contains: ${JSON.stringify(response)}`, { cause: getCause(response?.status || 500) });
            }
          }),
};

export const MappedAreaService: Readonly<typeof MappedAreaServiceImplementation> = MappedAreaServiceImplementation;
